import { makeActionCreator } from "../utils";

export const SHOW_SIDEBAR_MENU_CHANGED = "DASHBOARD_UI.SHOW_SIDEBAR_MENU_CHANGED";

export const showSidebarMenuChanged = makeActionCreator(SHOW_SIDEBAR_MENU_CHANGED, "payload");
